import React, { useEffect, useMemo, useState } from "react";

import Sidebar from "../../partials/Sidebar";
import Header from "../../partials/Header";
import DeleteButton from "../../partials/actions/DeleteButton";
import DateSelect from "../../components/DateSelect";
import FilterButton from "../../components/DropdownFilter";
import CustomersTable from "../../partials/customers/CustomersTable";
import PaginationClassic from "../../components/PaginationClassic";
import { getCustomers } from "../../api/customers.js";
import PaginationNumeric from "../../components/PaginationNumeric.jsx";
import { useSelector } from "react-redux";

function Customers() {
  const [selectedItems, setSelectedItems] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearch, setCurrentSearch] = useState("");
  const [currentGlobal, setCurrentGlobal] = useState(false);
  const { selectedLocation } = useSelector((state) => state.app);
  const totalPages = useMemo(() => {
    return Math.ceil(totalRecords / limit);
  }, [totalRecords, limit]);

  const handleSelectedItems = (selectedItems) => {
    setSelectedItems([...selectedItems]);
  };

  const handleSearch = (query, global = false) => {
    setSearchQuery(query);
    setCurrentSearch(query);
    setCurrentGlobal(global);
    setPage(1); // Reset to first page when searching
    getCustomers(1, limit, query, global).then((res) => {
      setCustomers(res.data);
      setTotalRecords(res.pagination.total);
    });
  };

  const fetchCustomers = () => {
    getCustomers(page, limit, currentSearch, currentGlobal).then((res) => {
      setCustomers(res.data);
      setTotalRecords(res.pagination.total);
    });
  };

  useEffect(() => {
    fetchCustomers();
  }, [page, limit]);

  useEffect(() => {
    if (selectedLocation) {
      // Reset to first page and clear search when location changes
      setPage(1);
      setSearchQuery("");
      setCurrentSearch("");
      setCurrentGlobal(false);
      getCustomers(1, limit, "", false).then((res) => {
        setCustomers(res.data);
        setTotalRecords(res.pagination.total);
      });
    }
  }, [selectedLocation]);

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      {/* Page header */}
      <div className="sm:flex sm:justify-between sm:items-center mb-8">
        {/* Left: Title */}
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
            Customers 
          </h1>
        </div>

        {/* Right: Actions */}
        {/*<div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">*/}
        {/*  /!* Delete button *!/*/}
        {/*  <DeleteButton selectedItems={selectedItems} />*/}

        {/*  /!* Filter button *!/*/}
        {/*  <FilterButton align="right" />*/}
        {/*</div>*/}
      </div>

      {/* Table */}
      <CustomersTable
        selectedItems={handleSelectedItems}
        customers={customers}
        totalRecords={totalRecords}
        onSearch={handleSearch}
      />

      {/* Pagination */}
      <div className="mt-8">
        <PaginationNumeric
          onSelect={(p) => setPage(p + 1)}
          currentPage={page - 1}
          totalPages={totalPages}
          isFirstPage={page === 1}
          isLastPage={page === totalPages}
        />
      </div>
    </div>
  );
}

export default Customers;
